import { useMutation } from '@tanstack/react-query';
import { updateUserHabitStatisticsTimeframe } from 'shared/services/backend-api';
import { InsightsTimeframes } from 'shared/types/insights';

export const useUpdateHabitStatisticsTimeframeMutation = () =>
  useMutation({
    mutationFn: async (timeframe: InsightsTimeframes) =>
      updateUserHabitStatisticsTimeframe(timeframe),
  });
